import { render, staticRenderFns } from "./monday-onboarding.page.vue?vue&type=template&id=e374ceec&"
import script from "./monday-onboarding.page.vue?vue&type=script&lang=js&"
export * from "./monday-onboarding.page.vue?vue&type=script&lang=js&"
import style0 from "./monday-onboarding.page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports